
import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Observable, Subscription } from 'rxjs';
import { startWith, map, mergeMap, debounceTime, filter } from 'rxjs/operators';

import { InterfaceElement } from '../model/asd/asd-properties/asd-ie/asd-interfaceElement';
import { CosyCommunicationControllerService, SearchOption } from '../service/controller/cosy-communication-controller.service';
import { FlexSearchRequest, Filter } from '../model/server/flexSearchRequest';
import { Attribute } from '../model/asd/asd-properties/asd-attribute';
import { UXControllerService } from '../service/controller/ux-controller.service';
/**
 * @title Option groups autocomplete
 */
@Component({
  selector: 'app-cosy-autocomplete',
  templateUrl: './cosy-autocomplete.component.html',
  styleUrls: ['./cosy-autocomplete.component.css'],
})

export class CosyAutocompleteComponent implements OnInit {
  @ViewChild('autocompleteInput') autocompleteInput: ElementRef;
  @Input() ie: InterfaceElement;
  myControl = new FormControl();
  options: any[] = [];
  filteredOptions: Observable<string[]>;
  autoCompleteDataItem: FlexSearchRequest = new FlexSearchRequest();
  flexSearchRequest: FlexSearchRequest = new FlexSearchRequest();

  private subscriptionCollTreeSearch: Subscription;
  private searchValue: string = '';
  public placeholder: string;
  public searchedTerm: string = '';


  constructor(
    public cosyCommunicationControllerService: CosyCommunicationControllerService,
    private uxControllerService: UXControllerService
  ) {
    this.subscriptionCollTreeSearch = this.uxControllerService.executeCollTreeSearch.subscribe(
      (so: SearchOption) => {
        this.cosyCommunicationControllerService.searchOption = [];
        this.cosyCommunicationControllerService.searchOption.push(so);
        this.processSearchAction('');
      }
    );
  };

  ngOnInit() {
   
    if(this.ie.Values!= null && this.ie.Values.length > 0 && this.ie.Values[0].Value!= '' && this.ie.Values[0].Value.indexOf('~') < 0){
      this.myControl.setValue(this.ie.Values[0].Value);
    }
    
    this.flexSearchRequest = this.configFilters();
   
    (this.ie.PreLabel.DisplayName != null) ? this.placeholder = this.ie.PreLabel.DisplayName : this.placeholder = this.ie.Label.DisplayName;
    this.filteredOptions = this.myControl.valueChanges.pipe(
      debounceTime(300),
      filter(value => String(typeof value) !== 'object'),
      startWith(''),
      map(value1 => {
        this.searchValue = value1;
        this.flexSearchRequest.cosyToken = this.uxControllerService.sessionID;
        if (this.ie.ObjectID == null) this.flexSearchRequest.entityID = this.uxControllerService.ieEntityList.ObjectID;
        else this.flexSearchRequest.entityID = this.ie.ObjectID;
        this.flexSearchRequest.searchText = value1;
      }),
      mergeMap(value2 => this.cosyCommunicationControllerService.getSearchData(this.flexSearchRequest).pipe(map(
        searchData => {
          this.options = [];
          if (searchData['Filters'] != null) {
            this.autoCompleteDataItem.filters = searchData['Filters'];
            let type: string = '';
            this.autoCompleteDataItem.filters.forEach(filter => { type = filter.type; filter.items.forEach(item => { this.options.push({ 'id': item.ID, 'displayName': item.displayName + ' - ' + type, 'type': type }) }); });
          }
        }))
      ),
      map(value => this._filter(this.searchValue))
    );
    let search: string = this.ie.Values[0].Value;
    let searchArr: string[];
    if (!search.startsWith('~')) this.searchedTerm = search;
    else {
      searchArr = search.split('~');
      this.searchedTerm = searchArr[searchArr.length - 1];
    }
    this.myControl.setValue(this.searchedTerm);
  }

  ngOnDestroy() {
    this.subscriptionCollTreeSearch.unsubscribe();
  }

  private _filter(value: string): string[] {
    const filterValue = value.replace('%', '').toLowerCase();
    return this.options.filter(option => option['displayName'].toLowerCase().includes(filterValue));
    //return this.options;
  }

  reset(value){
    if(value == ''){
      this.processSearchAction('');
    }
  }

  filterPostList(event) {
    var value = event.source.value;
    let so: SearchOption = new SearchOption();
    so.type = value.type;
    switch (so.type) {
      case 'DataRealms': {
        so.searchString = '~data:' + value.id + '~';
        break;
      }
      case 'Collections': {
        so.searchString = '~coll:' + value.id + '~';
        break;
      }
      case 'Items': {
        so.searchString = '~item:' + value.id + '~';
        break;
      }
    }
    so.ID = value.id;
    so.displayName = value.displayName;
    this.cosyCommunicationControllerService.searchOption.push(so);


    if (this.cosyCommunicationControllerService.searchOption.length > 0) {
      let searchText: string = '';
      this.cosyCommunicationControllerService.searchOption.forEach(element => searchText += element.searchString);

      if (value.type == 'Items') this.cosyCommunicationControllerService.searchOption.pop();
      this.processSearchAction(searchText);
    }
    else if (value.displayName != '') this.processSearchAction(value.displayName);
  }

  removeOption(option) {
    let index = this.cosyCommunicationControllerService.searchOption.indexOf(option);
    if (index >= 0) this.cosyCommunicationControllerService.searchOption.splice(index, 1);
    let searchText: string = '';
    this.cosyCommunicationControllerService.searchOption.forEach(element => searchText += element.searchString);
    this.processSearchAction(searchText);
  }

  focusOnPlaceInput() {
    this.autocompleteInput.nativeElement.focus();
    this.autocompleteInput.nativeElement.value = '';
  }

  processSearchAction(searchText: string) {

    let additionalIEs: InterfaceElement[] = [];
    let attribute: Attribute = new Attribute();
    let ielist: InterfaceElement = new InterfaceElement();
    attribute.ActivePage = 1;
    ielist.InterfaceElementID = this.uxControllerService.ieEntityList.InterfaceElementID;
    ielist.Values = this.uxControllerService.ieEntityList.Values;
    ielist.Attributes = attribute;
    additionalIEs.push(ielist);

    if (searchText == '') {
      let searchValue = this.autocompleteInput.nativeElement.value;
      this.cosyCommunicationControllerService.searchOption.forEach(element => searchText += element.searchString);
      if (searchValue != '') searchText += searchValue;
    }
    if (this.ie.Attributes.OnSelectUAID != null) {
      this.uxControllerService.fetchUserAction(this.ie.Attributes.OnSelectUAID, this.ie, null, searchText, null, null, additionalIEs, null, null);
    }
   // this.focusOnPlaceInput();
  }

  configFilters(): FlexSearchRequest {
    let flexSearchRequest: FlexSearchRequest = new FlexSearchRequest();
    let filters: Filter[] = [];
    flexSearchRequest.filters = filters;
    let filterData: Filter = new Filter();
    filterData.type = 'DataRealms';
    if (this.uxControllerService.ActivePrimaryGroup == '67faa3df-1743-4368-b905-58a433ce1693' || this.uxControllerService.ActivePrimaryGroup == 'f8e8e32a-fc49-417a-875a-aa463a256a9c') filterData.enabled = true;
    else if (this.ie.CustomizeOptions != null && this.ie.CustomizeOptions.Properties != null && this.ie.CustomizeOptions.Properties.FilterDataEnable != null)
      filterData.enabled = this.ie.CustomizeOptions.Properties.FilterDataEnable;
    else
      filterData.enabled = false;
    flexSearchRequest.filters.push(filterData)
    let filterCol: Filter = new Filter();
    filterCol.type = 'Collections';
    if (this.ie.CustomizeOptions != null && this.ie.CustomizeOptions.Properties != null && this.ie.CustomizeOptions.Properties.FilterColEnable != null){
      filterCol.enabled = this.ie.CustomizeOptions.Properties.FilterColEnable;
      filterCol.typeFilter = this.ie.CustomizeOptions.Properties.TypeFilterCol;
    }
    else
      filterCol.enabled = true;
    flexSearchRequest.filters.push(filterCol)
    let filterItem: Filter = new Filter();
    filterItem.type = 'Items';
    if (this.ie.CustomizeOptions != null && this.ie.CustomizeOptions.Properties != null && this.ie.CustomizeOptions.Properties.FilterItemEnable != null)
      filterItem.enabled = this.ie.CustomizeOptions.Properties.FilterItemEnable;
    else
      filterItem.enabled = false;
    flexSearchRequest.filters.push(filterItem)
    return flexSearchRequest;
  }

}
